module.exports = __webpack_public_path__ + "static/media/token.5d25ebd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/ibm/token.png
// module id = 111
// module chunks = 0